<template>
  <button
    type="button"
    class="currency-modal-trigger button button--text"
    @click="() => openModal()"
  >
    <responsive-image
      :image="{
        src: activeCurrencyFlagUrl,
        alt: activeCurrencyFlagAlt
      }"
      :alt="activeCurrencyFlagAlt"
      class="currency-modal-trigger__flag"
    />
    <template v-if="displayName !== ''">
      <span
        class="currency-modal-trigger__title"
        v-text="displayName"
      />
      <icon-arrow-down-filled class="currency-modal-trigger__icon" />
    </template>
  </button>
</template>

<script>

/**
 * Vue: Currency modal trigger (currency-modal-trigger)
 * -----------------------------------------------------------------------------
 * Button that opens the currency modal
 *
 * @param {Object} displayName - The current country's display name
 *
 */

import { mapActions } from 'vuex'
import ResponsiveImage from '~global/images/responsive-image'
import IconArrowDownFilled from '~icons/direction/arrow/down-filled.svg'

export default {
  name: 'CurrencyModalTrigger',

  components: {
    IconArrowDownFilled,
    ResponsiveImage,
  },

  props: {
    displayName: {
      type: String,
      default: '',
    },
  },

  data() {
    return {}
  },

  computed: {

    /**
     * The current country flag image's alt text.
     * @returns {String}
     */
    activeCurrencyFlagAlt() {
      if (!window.Shopify.country) {
        return 'US flag'
      }
      return `${window.Shopify.country} flag`
    },

    /**
     * The current country flag image's URL.
     * @returns {String}
     */
    activeCurrencyFlagUrl() {
      if (!window.Shopify.country) {
        return this.getFlag('us')
      }
      return this.getFlag(window.Shopify.country.toLowerCase())
    },
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      openOverlay: 'overlays/open',
    }),

    /**
     * Get flag image.
     * @param {String} code - country code.
     * @returns {String}
     */
    getFlag(code) {
      return `https://cdn.shopify.com/static/images/flags/${code.toLowerCase()}.svg`
    },

    /**
     * Open the currency modal.
     */
    openModal() {
      this.openOverlay({
        ignoreDismissed: true,
        namespace: 'currencyModal',
      })
    },
  },
}
</script>

<style lang="scss">
@import './currency-modal-trigger';
</style>
